module.exports = __webpack_public_path__ + "med-nurse-icon.png?0cf58a886c813db39147f5e4ec879e13";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/med-nurse-icon.png
// module id = 229
// module chunks = 0